import React, { useContext, useEffect } from "react";
import { FoundersType, ResultContext } from "../ResultContext";
import { GivenQuestions } from "../constants/Questions";
import { DropdownBox } from "../components/DropdownBox";
import { Tags } from "../components/Tags";

export function ResponsibilitiesInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const currentQuestion = GivenQuestions.find((q) => q.id === questionId) as {
    dependsOn: number;
  };

  const dependsOn = currentQuestion.dependsOn as number;

  const dependsOnResult =
    (result[dependsOn] as {
      name: string;
      type: FoundersType;
    }[]) || [];

  const foundResult =
    (result[questionId] as { tags: string[]; extra: string }[]) ||
    Array.from({ length: dependsOnResult.length }, () => {
      return { tags: [], extra: "" };
    });

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = Array.from({ length: dependsOnResult.length }, () => {
        return { tags: [], extra: "" };
      });

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  if (dependsOnResult.length > foundResult.length) {
    const diff = dependsOnResult.length - foundResult.length;

    for (let i = 0; i < diff; i++) {
      foundResult.push({ tags: [], extra: "" });
    }
  }

  const defaultTags = [
    "General management",
    "CEO orientated role",
    "CFO orientated role",
    "CTO orientated role",
    "CSO orientated role",
    "CMO orientated role",
    "Legal stuff",
    "Stay focused",
    "Be tolerant",
    "Have a sense of humor",
    "Work hard play hard",
    "Chief happiness officer",
    "Dr. No (CFO)",
    "VP of ABC (always be closing)",
    "Collector of business cards",
  ];

  return (
    <div className="flex flex-column">
      {dependsOnResult.length === 1 && dependsOnResult[0].name === ""
        ? null
        : dependsOnResult.map((item, index) => {
            return (
              <div className={`${index !== 0 ? "mt-4" : ""}`}>
                <DropdownBox title={`${item.name}`} defaultOpen={true}>
                  <Tags
                    data={foundResult[index]}
                    setData={(data) => {
                      const copy = { ...result };

                      copy[questionId] = foundResult.map((it, id) => {
                        if (id === index) {
                          return data;
                        }

                        return it;
                      });

                      setResult(copy);
                    }}
                    options={defaultTags}
                    defaultOptions={[]}
                    disablePopUp={false}
                  />
                </DropdownBox>
              </div>
            );
          })}
    </div>
  );
}
